export default "__VITE_ASSET__CNFC6CHD__"